export const navItems = [
  { label: "Úvod", path: "/" },
  { label: "Služby", path: "/sluzby" },
  { label: "Ceník", path: "/cenik" },
  { label: "Realizace", path: "/realizace" },
  { label: "Kontakt", path: "/kontakt" },
];

export const services = [
  {
    title: "Elektroinstalace domu a bytu",
    description: "Nove rozvody, zasuvky, osvetleni, rozvadece a priprava pro revizi.",
    price: "od 45 000 Kc",
  },
  {
    title: "Rekonstrukce elektroinstalace",
    description: "Vymena starych rozvodu, uprava okruhu a sladeni s novymi spotrebici.",
    price: "od 28 000 Kc",
  },
  {
    title: "Revize a servis",
    description: "Revizni zpravy, odstraneni zavad, kontrola bezpecnosti a rychle opravy.",
    price: "od 2 500 Kc",
  },
  {
    title: "Datove rozvody",
    description: "UTP kabelaz, rack, Wi-Fi body, pripojeni TV a priprava chytre domacnosti.",
    price: "od 300 Kc / bod",
  },
];

export function formatPhone(value) {
    const digits = String(value).replace(/\D/g, "")

    return digits.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3")
}

export const contacts = {
    tel: 777850550,
    email: 'tomas@eltt.cz',
    ico: 23836059,
    ticr: '14759/26/EZ-M,O-E2A'
}